/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { SearchPhysicianViewModel } from './SearchPhysicianViewModel'; 

export function getPhysiciansOptions(onSuccess?: (result: SearchPhysicianViewModel[]) => void) {
	return queryOptions({
		queryKey: ['physicians'],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/libraries/physicians/queries/getphysicians/';
			const resp = await axios.get<SearchPhysicianViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: true
	});
}